import { UI_SET_LOADING_ACTION } from './actionTypes'

export default function uiSetLoadingAction(payload) {
  return {
    type: UI_SET_LOADING_ACTION,
    payload,
  }
}
